function About() {
  return <h1>Hello, from About page</h1>;
}

export { About };
